import { jsx as _jsx } from "react/jsx-runtime";
import hash from "object-hash";
// components
import { BreadcrumbContainer } from "./breadcrumb.styles";
import { LinkItem } from "../linkitem";
export const Breadcrumb = ({ items, previewId, previewIdExtractor, }) => (_jsx(BreadcrumbContainer, Object.assign({ "data-preview-id": previewId }, { children: items === null || items === void 0 ? void 0 : items.map((item, i) => (_jsx(LinkItem, { previewId: typeof previewIdExtractor === "function"
            ? previewIdExtractor(item, i)
            : undefined, data: item, index: i, isLast: items.length === i + 1 }, hash(item)))) })));
